import popupStyles from "./planChangeImpactConfirmation/planChangeImpactConfirmation.module.css";
import { tWithKeyAttr as t } from "../../i18nHelper";
import { ResourceCapImpact } from "../../services/api/resourceCaps.api";

interface ResourceImpactLineProps {
  testId: string;
  resource: ResourceCapImpact;
  summaryKey: string;
}

// Shared by planChangeImpactConfirmation (switch-plan impact) and cancelSeatPackConfirmation
// (end-of-pack impact) — same ResourceCapImpact shape, same zero-impact rule, different wording.
// Every field a summaryKey could interpolate already lives on `resource`, `count` included
// (aliasing `overBy` so a message can drive i18next's own `_one`/`_other` pluralization off it).
export function renderResourceImpactLine({ testId, resource, summaryKey }: ResourceImpactLineProps) {
  // limit: null means unlimited/unconfigured, and overBy: 0 means nothing to report —
  // either one alone is enough to say this resource has no impact.
  if (resource.limit === null || resource.overBy === 0) {
    return null;
  }

  return (
    <p className={popupStyles.popup__text} data-testid={testId}>
      {t(summaryKey, { current: resource.current, limit: resource.limit, count: resource.overBy })}
    </p>
  );
}
